import flatpickr from "flatpickr";

import { setGuests, setVehicle } from "./instantBook/instantBook_scripts";
import { init_instantBook_listeners } from "./instantBook/event_listeners";
import { getGoogleMaps } from "./util/general_util";


const API = "https://bookings.spot2nite.com";

async function initMap(parkId:any) {



    const maps = await getGoogleMaps();

    const customMapType = new maps.ImageMapType({
        getTileUrl: function (coord, zoom) {
            const normalizedCoord = getNormalizedCoord(coord, zoom);

            if (!normalizedCoord) {
                return "";
            }

            const parkURL = `${API}/parks/${parkId}`;
            return `${parkURL}/map/${zoom}/${normalizedCoord.x}/${normalizedCoord.y}`;
        },
        tileSize: new maps.Size(256, 256),
        maxZoom: 4,
        minZoom: 0,
        // @ts-ignore
        radius: 1738000,
        name: "custom",
    });

    const map:google.maps.Map = new maps.Map(
        document.getElementById("map"),
        {
            center: { lat: 0, lng: 0 },
            zoom: 1,
            streetViewControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ["moon"],
            },
        },
    );

    // @ts-ignore
    map.minZoom = 0;
    // @ts-ignore
    map.zoom = 0;

    customMapType.setOpacity(0.5);
    map.mapTypes.set("custom", customMapType);
    map.setMapTypeId("custom");
    map.setZoom(2);

    return map;
}

// Normalizes the coords that tiles repeat across the x axis (horizontally)
// like the standard Google map tiles.
function getNormalizedCoord(coord:any, zoom:any) {
    const y = coord.y;
    let x = coord.x;
    // tile range in one direction range is dependent on zoom level
    // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
    const tileRange = 1 << zoom;

    // don't repeat across y-axis (vertically)
    if (y < 0 || y >= tileRange) {
        return null;
    }

    // repeat across x-axis
    if (x < 0 || x >= tileRange) {
        x = ((x % tileRange) + tileRange) % tileRange;
    }
    return { x: x, y: y };
}

function init_instantBookDatePicker(Date_inputEl:JQuery<HTMLElement>, allowed_dates:string[]|null) {
    if (
        Date_inputEl === null || Date_inputEl === undefined || Date_inputEl.length == 0
    ) return;
    let flatpickr_options:any = {
        mode: "range",
        altInput: true,
        allowInput:true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        disableMobile: true,
        onChange: (selectedDates: Array<Date>, dateStr: string, instance: any) => {
            if ((selectedDates.length > 1) && !($("#cgCardReserve").hasClass("d-none"))) {
                $("#instantBookForm").trigger("submit");
            }
        }
    };
    if (allowed_dates != null && allowed_dates.length > 0) {
        flatpickr_options.enable = allowed_dates;
    } else {
        flatpickr_options.enable = [];
    };
    window.instantBoook_Date_pickr = flatpickr(Date_inputEl, flatpickr_options);
};



export async function init_instantBook(is_tripPlanner:boolean) {
    if (window.availability == undefined) {
        window.availability = [];
    };
    init_instantBookDatePicker($("#instantBook_dates"), window.availability);
    setVehicle();
    setGuests();

    init_instantBook_listeners(is_tripPlanner);

    if (window.parkId != undefined) {
        const spotsMap:google.maps.Map = await initMap(window.parkId);
    };
};
